import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-scanner-filter',
  templateUrl: './scanner-filter.component.html'
})

export class ScannerFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private userService: UserService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: [''],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('ScannerFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('ScannerFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.userService.getScanners(this.form.controls.Name.value);
  }

  async ngOnInit() {

  }
}
